import React, { Component } from "react";
import { Segment, Statistic, Divider, Header } from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";

class TrafficStatistics extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      statistics: [],
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  retrieveData = () => {
    // Statistics data
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "statistics", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => this.setState({ statistics: data, ocupBanda: (data.ocupBanda).toFixed(0) }, () => {
        this.setBaudRateQuantity();
        this.setCycleTime();
      }))
      .catch((e) => {
        console.log("TrafficStatistics request interrupted: ", e);
      });
  }

  setBaudRateQuantity = () => {
    let baudRateKbps = this.state.statistics.baudRate / 1000;
    let baudRateMbps = this.state.statistics.baudRate / 1000000;

    // If the baur rate is greater then 1000 Kbps show it as Mbps
    if (baudRateKbps >= 1000.00) {
      document.getElementById("baud_rate_speed").innerHTML = baudRateMbps.toString().replace(".", ",");
      document.getElementById("baud_rate_order_of_magnitude").innerHTML = Strings.BAUD_RATE_MBPS;
    }
    else {
      document.getElementById("baud_rate_speed").innerHTML = baudRateKbps.toString().replace(".", ",");
      document.getElementById("baud_rate_order_of_magnitude").innerHTML = Strings.BAUD_RATE_KBPS;
    }
  }

  setCycleTime = () => {
    let cycleTimeMs = parseFloat(this.state.statistics.cycleTime);
    let cycleTimeS = parseFloat(this.state.statistics.cycleTime) / 1000;

    if (cycleTimeMs >= 1000.00) {
      document.getElementById("cycle_time").innerHTML = cycleTimeS.toFixed(2).toString().replace(".", ",");
      document.getElementById("cycle_time_order_of_magnitude").innerHTML = Strings.CYCLE_TIME_S;
    }
    else {
      document.getElementById("cycle_time").innerHTML = cycleTimeMs.toFixed(2).toString().replace(".", ",");
      document.getElementById("cycle_time_order_of_magnitude").innerHTML = Strings.CYCLE_TIME_MS;
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  render() {
    return (
      <Segment style={segmentStyle}>

        <Header as='h3' textAlign="center" color="teal">
          {Strings.DEVICENET_NETWORK_INFO}
        </Header>
        <Divider style={{ marginTop: "-8px" }} />

        <Statistic.Group size="small" widths={3}>
          <Statistic>
            <Statistic.Value id="baud_rate_speed"></Statistic.Value>
            <Statistic.Label id="baud_rate_order_of_magnitude" style={statisticLabelStyle}>{Strings.BAUD_RATE_KBPS}</Statistic.Label>
          </Statistic>

          <Statistic>
            <Statistic.Value>{this.state.ocupBanda}</Statistic.Value>
            <Statistic.Label style={statisticLabelStyle}>{Strings.OCUP_BANDA}</Statistic.Label>
          </Statistic>

          <Statistic>
            <Statistic.Value id="cycle_time"></Statistic.Value>
            <Statistic.Label id="cycle_time_order_of_magnitude" style={statisticLabelStyle}>{Strings.CYCLE_TIME_MS}</Statistic.Label>
          </Statistic>

        </Statistic.Group>

      </Segment>
    );
  }
}

const segmentStyle = {
  textAlign: "center"
};

const statisticLabelStyle = {
  textTransform: "none"
};

// const popupStyle = {
//   marginLeft: "4px"
// };

export default TrafficStatistics;
